module.exports = __webpack_public_path__ + "img/16_58.869f786e.png";